import { render, staticRenderFns } from "./InformationPanel.vue?vue&type=template&id=2a5956a5&scoped=true&"
import script from "./InformationPanel.vue?vue&type=script&lang=js&"
export * from "./InformationPanel.vue?vue&type=script&lang=js&"
import style0 from "./InformationPanel.vue?vue&type=style&index=0&id=2a5956a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5956a5",
  null
  
)

export default component.exports